(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.theme = {}));
})(this, (function (exports) {
    var nafColor$1 = {
    	signature: {
    		yellow: "#FFDB16",
    		white: "#FFFFFF",
    		black: "#1a1a1a",
    		yellow40: "#FFF0B8",
    		yellow20: "#FFF8DD",
    		yellow10: "#FFFAEC"
    	},
    	primary: {
    		spruce: "#062E2A",
    		kart: "#7BDB83",
    		park: "#267C4F",
    		moss: "#D3EAC2",
    		dew: "#E9F3E6"
    	},
    	secondary: {
    		fog: "#DCEEE8",
    		glacier: "#E1F9FF",
    		frost: "#E3EBFC",
    		heather: "#F6E6F2",
    		cloudberry: "#FFEBE6"
    	},
    	neutral: {
    		neutral1: "#F2F2F2",
    		neutral2: "#E8E8E8",
    		neutral3: "#C1C1C1",
    		neutral4: "#767676",
    		neutral5: "#666666",
    		neutral6: "#4D4D4D"
    	},
    	information: {
    		errorDark: "#C00015",
    		errorLight: "#ffe5e5",
    		warning: "#E57300",
    		warningLight: "#FFE5CC",
    		successDark: "#03892C",
    		succesLight: "#DEF1E4",
    		information: "#367af5",
    		informationLight: "#e3ebfc"
    	},
    	componentStates: {
    		elementDisabled: "#F2F2F2",
    		textDisabled: "#6B6B6B"
    	}
    };
    var theme = {
    	nafColor: nafColor$1
    };

    var nafColor = theme.nafColor;

    exports.nafColor = nafColor;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map
